window.hubspotForms = function () {
    /*
    if (window.regions.length > 0 && $('select[name="nearest_clinic"]').length > 0) {
        var nearestClinicsField = $('select[name="nearest_clinic"]');

        for (o = 0; o < window.regions.length; o++) {
            nearestClinicsField.append($('<option>', {
                value: window.regions[o],
                text: window.regions[o]
            }));
        }
    }
    */

    $('.hs-form fieldset').wrapInner("<div class='fieldset'></div>");

    $('.hs-fieldtype-select select').customSelect({
        block: 'select-custom-element'
    });

    $('.hs-fieldtype-text, .hs-fieldtype-date, .hs-fieldtype-select, .hs-fieldtype-textarea, .hs-fieldtype-phonenumber').find('label').addClass('hidden');

    $('.hs-fieldtype-date').each(function () {
        var placeholder = $(this).find('label').text();
        var inputdate = $(this).find('input');
        var attrrequired = inputdate.attr('required');

        if (typeof attrrequired !== typeof undefined && attrrequired !== false) {
            placeholder = '* ' + placeholder.replace('*', '') + '...';
        }

        if ($(this).find('.hs-datepicker').length > 0) {
            inputdate.attr('placeholder', placeholder);
        } else {
            $(this).find('label').text(placeholder).removeClass('hidden');
            $(this).closest('.fieldset').addClass('fieldset--column')
        }
    });

    // Move input in dom for checkboxes
    $('.hs-fieldtype-checkbox li.hs-form-checkbox').each(function () {
        booleancheckbox = $(this).find('input');
        $(this).prepend(booleancheckbox);
    });

    // Move input in dom for boolean checkboxes
    $('.hs-fieldtype-booleancheckbox li.hs-form-booleancheckbox').each(function () {
        booleancheckbox = $(this).find('input');
        $(this).prepend(booleancheckbox);

        booleancheckbox.on('change', function () {
            $('.hs-dependent-field').find('.hs-fieldtype-text, .hs-fieldtype-select, .hs-fieldtype-textarea').find('label').addClass('hidden');
        });
    });

    // Preselect the current clinic location before
    if ($('#js-location-map').length > 0 && $('select[name=nzh_closest_clinic]').length > 0) {
        var location = $('#js-location-map').data('location');

        $('select[name=nzh_closest_clinic]').val(location).change();
        $('select[name=nzh_closest_clinic]').customSelect('reset');
    }
}
